var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showNavBar)?_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickBack}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }